import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface MegaphoneIconProps {
  color?: string;
  isActive?: boolean;
  size?: number;
}

export default function MegaphoneIcon({ color = '#A19F97', isActive = false, size = 24 }: MegaphoneIconProps) {
  if (isActive) {
    return (
      <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
        <Path
          d="M15.3505 11.7593C15.3505 11.7593 7.67689 12.8888 6.71363 12.9893C5.75038 13.0899 4.22522 12.3342 3.68279 10.8431C3.14035 9.352 3.82225 7.79282 4.62496 7.25118C5.42767 6.70875 12.0002 2.66113 12.0002 2.66113"
          fill="#151515"
        />
        <Path
          d="M15.3505 11.7593C15.3505 11.7593 7.67689 12.8888 6.71363 12.9893C5.75038 13.0899 4.22522 12.3342 3.68279 10.8431C3.14035 9.352 3.82225 7.79282 4.62496 7.25118C5.42767 6.70875 12.0002 2.66113 12.0002 2.66113"
          stroke="#151515"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M6.91406 12.9625L8.14407 16.342C8.4765 17.255 9.48516 17.7261 10.3982 17.3928C11.3112 17.0613 11.7814 16.0518 11.4497 15.1396L10.4914 12.5068"
          stroke="#151515"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9224 6.38782C16.8419 8.9135 16.6676 11.2965 15.5324 11.7092C14.3972 12.1227 12.7318 10.4095 11.8123 7.88379C10.8929 5.35727 11.0681 2.97508 12.2024 2.56157C13.3375 2.14805 15.0029 3.86131 15.9224 6.38782Z"
          fill="white"
          stroke="#151515"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        d="M15.3505 11.7593C15.3505 11.7593 7.67689 12.8888 6.71363 12.9893C5.75038 13.0899 4.22522 12.3342 3.68279 10.8431C3.14035 9.352 3.82225 7.79282 4.62496 7.25118C5.42767 6.70875 12.0002 2.66113 12.0002 2.66113"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.91406 12.9625L8.14407 16.342C8.4765 17.255 9.48516 17.7261 10.3982 17.3928C11.3112 17.0613 11.7814 16.0518 11.4497 15.1396L10.4914 12.5068"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9224 6.38782C16.8419 8.9135 16.6676 11.2965 15.5324 11.7092C14.3972 12.1227 12.7318 10.4095 11.8123 7.88379C10.8929 5.35727 11.0681 2.97508 12.2024 2.56157C13.3375 2.14805 15.0029 3.86131 15.9224 6.38782Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
